import React from 'react';
import * as styles from '../styles/SweetAlertStyles';
var InfoIcon = function () { return (React.createElement("div", { style: Object.assign({}, styles.icon, styles.iconInfo) },
    React.createElement("div", { style: styles.iconInfoBefore }),
    React.createElement("div", { style: styles.iconInfoAfter }))); };
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map